











































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../../sjzx/modules/zbsjk/components/nav-left.vue";
import {
  GetHospitals as CdrGetHospitals,
  PostDataExport as CdrPostDataExport,
  GetDataExportTemplates,
} from "@/request/cdr";
import {
  GetHospitals as HdrGetHospitals,
  GetDataExportTemplates as HdrGetDataExportTemplates,
  GetDataExportTopics as HdrGetDataExportTopics,
  PostHdrDataExport,
} from "@/request/hdr";
import { PostDataExport as IdrPostDataExport } from "@/request/idr";
import {
  GetTemplatesOfGroup as CdrGetTemplatesOfGroup,
  GetTopicsOfTemplate as CdrGetTopics,
  GetZyyxTemplates as IdrGetTemplates,
  GetZyyxTopicsOfTemplate as IdrGetTopics,
} from "@/request/projects";
import SelectMultiSearch from "./select-multi-search.vue";
@Component({
  components: {
    Copy,
    MainHeader,
    LeftNav,
    SelectMultiSearch,
  },
})
export default class CdrDataExport extends Vue {
  private hospitals: any[] = [];
  private filters: any = {
    表格名称: "",
    hospital_ids: [],
    开始时间: "",
    结束时间: "",
    时间段: "",
    性别: "",
    最低年龄: "",
    最高年龄: "",
    条件: "全部条件",
    行研究指标: [],
    列研究指标: [],
    ageWay: "全部",
    age: [1990, 2020],
    timeWay: "全部",
    time: [],
  };
  private ifAllHospital: any = false;
  private searchedTemplates: any[] = [];
  private rightTemplatesGroup: any[] = [];
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  @Watch("center", { immediate: true, deep: true })
  private centerChange(e) {
    if (e.project_id) {
      this.fetchHospitals();
      this.fetchTemplates();
      this.fetchRightTemplates();
    }
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    const getHospitals$ = () => {
      switch (this.center["center"]) {
        case "临床科室数据中心":
        case "名中医传承数据中心":
          return CdrGetHospitals(this, params);
          break;
        case "治未病数据中心":
        case "中医影像数据中心":
          return HdrGetHospitals(this);
          break;
        default:
          return CdrGetHospitals(this, params);
          break;
      }
    };
    getHospitals$().then((data: any) => {
      this.hospitals = data;
    });
  }
  /**
   * @description 点选全部医院时
   */
  private allHospitalChange(value) {
    if (value) {
      this.filters.hospital_ids = [""];
    } else {
      this.filters.hospital_ids = [];
    }
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["行研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    const getTemplates$ = () => {
      switch (this.center["center"]) {
        case "临床科室数据中心":
        case "名中医传承数据中心":
          return CdrGetTemplatesOfGroup(
            this,
            this.center.project_id,
            this.center.group_id
          );
          break;
        case "治未病数据中心":
          return HdrGetDataExportTemplates(this);
          break;
        case "中医影像数据中心":
          return IdrGetTemplates(this);
          break;
        default:
          return CdrGetTemplatesOfGroup(
            this,
            this.center.project_id,
            this.center.group_id
          );
          break;
      }
    };
    getTemplates$().then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    const getTopicss$ = () => {
      switch (this.center["center"]) {
        case "临床科室数据中心":
        case "名中医传承数据中心":
          return CdrGetTopics(this, l.template_id);
          break;
        case "治未病数据中心":
          const params: any = {
            params: {
              template_id: l.template_id,
            },
          };
          return HdrGetDataExportTopics(this, params);
          break;
        case "中医影像数据中心":
          return IdrGetTopics(this, l.template_id);
          break;
        default:
          return CdrGetTopics(this, l.template_id);
          break;
      }
    };
    getTopicss$().then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["行研究指标"].splice(index, 1);
  }
  /**
   * @description 获得右侧可选的模板列表
   */
  private fetchRightTemplates() {
    switch (this.center["center"]) {
      case "临床科室数据中心":
      case "名中医传承数据中心":
        const params: any = {
          params: {
            group_id: this.center.group_id,
          },
        };
        GetDataExportTemplates(this, params).then((data: any) => {
          data.map((item: any) => {
            item.opened = false;
          });
          if (data.length > 0) {
            data[0].opened = true;
          }
          this.rightTemplatesGroup = data;
        });
        break;
      case "治未病数据中心":
      case "中医影像数据中心":
        break;
    }
  }
  // 右侧全选列研究指标
  private selectAllColumnTemplate() {
    switch (this.center["center"]) {
      case "临床科室数据中心":
      case "名中医传承数据中心":
        this.rightTemplatesGroup.forEach((group: any) => {
          group.templates.forEach((template: any) => {
            template["choice"] = true;
          });
        });
        break;
      case "治未病数据中心":
      case "中医影像数据中心":
        this.filters["列研究指标"] = [];
        this.searchedTemplates.forEach((template: any) => {
          this.filters["列研究指标"].push(template);
        });
        break;
    }

    this.$forceUpdate();
  }
  // 清除所有列研究指标
  private clearAllColumnTemplate() {
    switch (this.center["center"]) {
      case "临床科室数据中心":
      case "名中医传承数据中心":
        this.rightTemplatesGroup.forEach((group: any) => {
          group.templates.forEach((template: any) => {
            template["choice"] = false;
          });
        });
        break;
      case "治未病数据中心":
      case "中医影像数据中心":
        this.filters["列研究指标"] = [];
        break;
    }

    this.$forceUpdate();
  }
  /**
   * @description 导出
   */
  private startExport() {
    if (!this.filters["表格名称"]) {
      this.$message.warning("表格名称不能为空");
      return;
    }
    if (this.filters.hospital_ids.length === 0) {
      this.$message.warning("请选择要导出的所属机构");
      return;
    }
    let hospitalIds: any[] = this.filters["hospital_ids"];
    if (this.filters["hospital_ids"][0] === "") {
      hospitalIds = [];
    }
    const params: any = {
      表格名称: this.filters["表格名称"],
      project_id: this.center.project_id,
      hospital_ids: hospitalIds,
      时间段: this.filters["timeWay"],
      性别: this.filters["性别"],
      姓名身份: this.filters["姓名身份"],
      条件: this.filters["条件"],
    };
    // 时间段
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
    }
    // 年龄
    if (this.filters.ageWay === "自定义") {
      params["最低年龄"] = this.filters.age[0];
      params["最高年龄"] = this.filters.age[1];
    }
    if (this.filters["行研究指标"].length > 0) {
      const arr: any[] = [];
      this.filters["行研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["行研究指标"] = arr;
    }
    const loading = this.$loading({ text: "导出中..." });
    switch (this.center["center"]) {
      case "临床科室数据中心":
      case "名中医传承数据中心":
        this.filters["列研究指标"] = this.rightTemplatesGroup;
        params["列研究指标"] = this.filters["列研究指标"];

        CdrPostDataExport(this, params)
          .then((data: any) => {
            loading.close();
            window.open(
              window.API_ROOT + "api/wajue/download?filename=" + data.file_name
            );
          })
          .catch((err) => {
            console.log(err);
            loading.close();
          });
        break;
      case "治未病数据中心":
        params["列研究指标"] = this.filters["列研究指标"];
        PostHdrDataExport(this, params)
          .then((data: any) => {
            loading.close();
            window.open(
              window.API_ROOT + "api/wajue/download?filename=" + data.file_name
            );
          })
          .catch((err) => {
            console.log(err);
            loading.close();
          });
        break;
      case "中医影像数据中心":
        params["列研究指标"] = this.filters["列研究指标"];
        IdrPostDataExport(this, params)
          .then((data: any) => {
            loading.close();
            window.open(
              window.API_ROOT + "api/wajue/download?filename=" + data.file_name
            );
          })
          .catch((err) => {
            console.log(err);
            loading.close();
          });
        break;
    }
  }
}
